import * as React from "react";

export interface IRadioOption {
    key: string;
    value: number;
    name: string;
    isChecked: boolean;
}

const TypeOption: React.FunctionComponent<{
    handleChange: (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
    ) => void;
    radioOption: IRadioOption;
    name: string;
}> = (props: {
    handleChange: (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
    ) => void;
    radioOption: IRadioOption;
    name: string;
}) => {
    return (
        <div className="radio">
            <input
                id={props.radioOption.key}
                onChange={props.handleChange}
                type="radio"
                name={props.name}
                value={props.radioOption.value}
                checked={props.radioOption.isChecked}
            />
            <label className="radio-label" htmlFor={props.radioOption.key}>
                {props.radioOption.name}
            </label>
        </div>
    );
};

export const RadioList: React.FunctionComponent<{
    handleChange: (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
    ) => void;
    radioOptions: Array<IRadioOption>;
    name: string;
}> = (props: {
    handleChange: (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
    ) => void;
    radioOptions: Array<IRadioOption>;
    name: string;
}) => {
    return (
        <>
            {props.radioOptions.map((item) => (
                <TypeOption
                    key={item.value.toString()}
                    handleChange={props.handleChange}
                    radioOption={item}
                    name={props.name}
                />
            ))}
        </>
    );
};
